<template><div class="pr selectable" :class="{obsolete:!pr.current}">
  <div class="row">
    <a class="name" v-html="pr.name" :href="`/admin/web/locomotive/${this.pr.loco_id}/change/`" target="_blank" />
    <div class="created">{{ created_at }}, {{ pr.created_by }}, prid:{{ pr.id }}</div>
  </div>
  <table>
    <tr><th>Serial</th><td v-html="pr.serial_no" /></tr>
    <tr><th>IMEI</th><td v-html="pr.imei" /></tr>
    <tr><th>Part</th><td v-html="parts.dict[pr.part]" /></tr>
    <tr><th>MAC/LAN</th><td v-html="pr.mac" /></tr>
  </table>
  <table>
    <tr><th>Sim ICCID</th><td v-html="pr.sim" /></tr>
    <tr><th>FW Version</th><td v-html="pr.firmware_version" /></tr>
    <tr><th>Config Version</th><td v-html="pr.config_version" /></tr>
    <tr><th>Connected</th><td v-html="connected_at" /></tr>
  </table>
  <div class="pr-status">
    <span v-if="!pr.current">This record is obselete.</span>
    <span class="no-connection" v-else-if="!pr.status || !pr.status.length">No connection (yet?)</span>
    <span class="offline" v-else-if="pr.status.length === 1">Offline</span>
    <span class="no-heartbeat" v-else-if="pr.status[1] === false">No heartbeat</span>
    <span class="no-gps" v-else-if="pr.status[1] === true">On-line, no GPS fix</span>
    <a
      v-else
      target="_blank"
      :href="`https://www.google.com/maps?t=k&q=loc:${pr.status[1][0]},${pr.status[1][1]}`">
        On-line, GPS fix</a>
  </div>
  <button class="edit material-icons" title="Edit" @click="$emit('edit')">edit</button>
</div></template>
<script>
import moment from 'moment'
export default {
  name: 'provisioning-card',
  props: ['pr','parts'],
  emits: ['edit'],
  computed: {
    created_at() { return moment.unix(this.pr.created_at).format('YYYY-MMM-DD hh:mm:ss') },
    connected_at() {
      return (
        this.pr.connected === null
          ? null
          : moment.unix(this.pr.connected).format('YYYY-MMM-DD hh:mm:ss')
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.pr {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  background-color: #fff;
  flex-basis: 0;

  &.obsolete {
    color: #444;
    background-color: #aaa;
    table { td, th { border: 1px solid #888; } }
  }

  display: grid;
  grid-template:
    "a a e" auto
    "b c e" auto
    "d d e" auto;
  gap: 5px;

  .name { font-weight: bold; }
  .created { font-size: 80%; }
  .row {
    white-space: nowrap;
    grid-area: a;

    display: flex;
    gap: 5px;
    align-items: baseline;
  }
  table {
    border-collapse: collapse;
    font-size: 80%;
    white-space: nowrap;
    th, td { border: 1px solid #aaa; padding: .1em .3em; }
    td { min-width: 3em; }
    &:first-child { grid-area: b; }
    &:last-child { grid-area: c; }
  }
  .pr-status {
    font-size: 80%;
    grid-area: d;
    > * { &::before { content: "⬤ "; } }
    > .no-connection { color: #aaa; }
    > .offline { color: #666; }
    > .no-heartbeat { color: #f00; }
    > .no-gps { color: #f80; }
    > a { color: #0c0; }
  }
  > .edit { grid-area: e; }
}
</style>
